module.exports = __webpack_public_path__ + "static/media/autMenores.98ac070f.pdf";